"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
const CademyError_1 = __importDefault(require("../CademyError"));
const Str_1 = __importDefault(require("../Str"));
class ValidationError extends CademyError_1.default {
    constructor(properties = [], detail, instance) {
        super('generic/validation-error', 'Validation Error', generateDetail(properties, detail), 400, instance, { properties });
        this.properties = properties;
    }
    toObject() {
        const parent = super.toObject();
        return Object.assign(Object.assign({}, parent), { properties: this.properties });
    }
    toJSON() {
        return this.toObject();
    }
    get isEmpty() {
        return this.properties.length === 0;
    }
    static getNested(error, key) {
        const prefix = `${key}.`;
        const nestedProperties = error.properties.filter((property) => property.key.startsWith(prefix));
        const newProperties = nestedProperties.map((property) => (Object.assign(Object.assign({}, property), { key: property.key.replace(prefix, '') })));
        return new ValidationError(newProperties);
    }
    static merge(...errors) {
        const properties = errors.flatMap((error) => error.properties);
        return new ValidationError(properties);
    }
    static prefixProperties(error, prefix) {
        const prefixedProperties = error.properties.map((property) => {
            return Object.assign(Object.assign({}, property), { key: `${prefix}${property.key}` });
        });
        return new ValidationError(prefixedProperties);
    }
    static objectMerge(object) {
        const prefixedValidationErrors = Object.entries(object).map(([key, error]) => {
            return ValidationError.prefixProperties(error, `${key}.`);
        });
        return ValidationError.merge(...prefixedValidationErrors);
    }
    static createCademyError(error) {
        if (error.type !== new ValidationError().type) {
            return null;
        }
        if (!error.extensions) {
            return null;
        }
        if ('properties' in error.extensions === false) {
            return null;
        }
        const convertableError = error.toObject();
        return new ValidationError(convertableError.properties, error.detail, error.instance);
    }
}
exports.ValidationError = ValidationError;
const generateDetail = (properties, detail) => {
    if (detail) {
        return detail;
    }
    if (properties.length === 0) {
        return undefined;
    }
    const firstProperty = properties[0];
    const simplifiedKey = Str_1.default.toTitleCase(firstProperty.key.split('.').slice(-1)[0]);
    return `${firstProperty.name || simplifiedKey} ${firstProperty.message}`;
};
exports.default = ValidationError;
